import { Canvas } from "@react-three/fiber";
import React, { FC, PropsWithChildren, Suspense } from "react";

import { initialCameraPosition } from "./constants";

export interface WorldCanvasWrapperProps {
  variant: "desktop" | "mobile";
}

export const WorldCanvasWrapper: FC<PropsWithChildren<WorldCanvasWrapperProps>> = ({
  variant,
  children,
}) => {
  return (
    <>
      <div className="z-10 absolute top-0 left-0 flex justify-center items-center w-full h-full">
        <div className="border-gray-300 h-20 w-20 animate-spin rounded-full border-4 border-t-primary" />
      </div>
      <Canvas
        style={{
          margin: "auto",
          width: variant === "desktop" ? "50vw" : undefined,
          zIndex: 11,
        }}
        camera={{ fov: 55, position: initialCameraPosition }}
      >
        <Suspense fallback={null}>{children}</Suspense>
      </Canvas>
    </>
  );
};
